import { render, staticRenderFns } from "./BucketAdvancedTab.vue?vue&type=template&id=794ff9d0"
import script from "./BucketAdvancedTab.vue?vue&type=script&lang=js"
export * from "./BucketAdvancedTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports